import { render, staticRenderFns } from "./NewReports.vue?vue&type=template&id=cd8b1810&"
import script from "./NewReports.vue?vue&type=script&lang=js&"
export * from "./NewReports.vue?vue&type=script&lang=js&"
import style0 from "./NewReports.vue?vue&type=style&index=0&id=cd8b1810&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports